import { Link } from 'react-router-dom'

function FoundersCard() {
    return (
        <div className="founders-card">
            <div className="founders-card__image-wrap">
                <img
                    src="/motiejus-2026.jpg"
                    alt="Motiejus Apanavičius, founder of PostPaid"
                    className="founders-card__image"
                    width={320}
                    height={320}
                    loading="lazy"
                    decoding="async"
                />
            </div>
            <div className="founders-card__body">
                <span className="mono-label">founder</span>
                <h3 className="founders-card__name">Motiejus Apanavičius</h3>
                <p className="founders-card__role">Founder &amp; Engineer</p>
                <blockquote className="founders-card__quote">
                    "I built PostPaid because flat-fee influencer deals are broken — brands pay regardless of results, and creators with smaller audiences get locked out. Pay-per-interaction fixes both sides at once."
                </blockquote>
                <div className="founders-card__links">
                    <a href="https://www.linkedin.com/in/motiejus-apanavi%C4%8Dius-51544133a/" target="_blank" rel="noopener noreferrer" className="founders-card__link">LinkedIn →</a>
                    <Link to="/about" className="founders-card__link">
                        Read more about us →
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default FoundersCard
